<div fxLayout="column" fxLayoutGap="14px">
    <h3>General</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-form-field fxFlex>
            <mat-label i18n="@@title">Title</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. Headphones" [(ngModel)]="asset.title" required />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@description">Description</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. Headphones" [(ngModel)]="asset.description"
                required />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@hint">Hint</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. Length: 5m" [(ngModel)]="asset.hint" required (ngModelChange)="assetChanged.emit(asset)"/>
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@manfacturer">Manufacturer</mat-label>
            <input matInput i18n-placeholder placeholder="e.g. Sennheiser" [(ngModel)]="asset.manufacturer"
                required />
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@state">State</mat-label>
            <mat-select [(value)]="currentState" i18n-placeholder="@@state" placeholder="state" required
                (selectionChange)="updateState()">
                <mat-select-trigger *ngIf="currentState" class="mark">
                    <mat-icon matSuffix [ngStyle]="{'color': currentState.color}">{{currentState.icon}}</mat-icon>
                    <span>{{currentState.name}}</span>
                </mat-select-trigger>
                <!-- <mat-option [value]="null">
                    <mat-icon [ngStyle]="{'opacity': 0}">brightness_1</mat-icon>
                    <span>Not selected</span>
                  </mat-option> -->
                <mat-option *ngFor="let state of allAssetStates" [value]="state">
                    <mat-icon matSuffix [ngStyle]="{'color': state.color}">{{state.icon}}</mat-icon>
                    <span>{{state.name}}</span>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <h3>Place</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">

        <mat-form-field fxFlex>
            <mat-label i18n="@@place">Place</mat-label>
            <mat-select [(value)]="asset._placeId" required (selectionChange)="assetChanged.emit(asset)">
                <mat-option *ngFor="let element of places" [value]="element._id">
                    {{element.title}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@room">Room</mat-label>
            <input matInput i18n-placeholder="@@room" placeholder="room" [(ngModel)]="asset.room" required (ngModelChange)="assetChanged.emit(asset)"/>
        </mat-form-field>
    </div>



    <h3>Aquisition</h3>
    <div fxLayout="row wrap" fxLayoutGap="10px">

        <mat-form-field fxFlex>
            <mat-label i18n="@@class">Class</mat-label>
            <mat-select [(value)]="asset._classId" required (selectionChange)="assetChanged.emit(asset)">
                <mat-option *ngFor="let element of classes" [value]="element._id">
                    {{element.title}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@aquisitionDate">Aquisition Date</mat-label>
            <input matInput [matDatepicker]="aquisitionDatePicker" [formControl]="date">
            <mat-datepicker-toggle matSuffix [for]="aquisitionDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #aquisitionDatePicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field fxFlex>
            <mat-label i18n="@@aquisitionValue">Aquisition Value</mat-label>
            <input matInput type="number" i18n-placeholder="@@aquisitionValue" placeholder="aquisitionValue"
                [(ngModel)]="asset.aquisitionValue" required />
            <span matSuffix>€</span>
        </mat-form-field>
    </div>
</div>